<template>
    <el-dialog title="用户编辑"
        :visible="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="cancel"
        width="60%">
        <el-form :model="currentRow" ref="form" label-width="120px">
            <el-form-item label="帐号名称" :rules="rules.requiredItem" prop="name">
                <el-input v-model="currentRow.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="帐号昵称" :rules="rules.requiredItem" prop="alias">
                <el-input v-model="currentRow.alias"></el-input>
            </el-form-item>
            <!-- <el-form-item label="帐号密码" prop="pwd">
                <el-input v-model="form.pwd" readonly></el-input>
            </el-form-item> -->
            <el-form-item label="帐号状态">
                <el-radio v-model="currentRow.status" :label="1">启用</el-radio>
                <el-radio v-model="currentRow.status" :label="0">禁用</el-radio>
            </el-form-item>
            <el-form-item label="分配角色" prop="role">
                <el-select v-model="currentRow.roleIds" multiple>
                    <el-option v-for="role in roleList" :key="role.id"
                        :label="role.name"
                        :value="role.id"
                        ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save">保存</el-button>
                <el-button @click="cancel(false)">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
import { Loading } from "element-ui"
export default {
    props: {
        currentRow: {
            type: Object
        },
        visible: {
            type: Boolean
        }
    },
    data: vm=>({
        roleList: [],
        rules: {
            requiredItem: [{required: true, message: '必填项'}]
        },
        // form: {
        //     id: '',
        //     alias: '',
        //     name: '',
        //     status: true,
        //     roleIds: [],
        //     roleDtos: [],
        // }
    }),
    created(){
        this.getRoleList()

        // if(this.userId){
        //     this.findById()
        // }
    },
    methods: {
        setRoleIds(roleDtos){
            let ids = []
            roleDtos.forEach(role => {
                ids.push(role.id)
            })
            return ids
        },
        findById(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios
                .get(this.baseUrl3 + "user/findById/" + this.userId)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        // this.roleList = data.list
                        this.form = data
                        this.form.roleIds = []
                        if(data.roleDtos){
                            this.form.roleIds = this.setRoleIds(data.roleDtos)
                        }
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        getRoleList(){
            this.$axios
                .get(this.baseUrl3 + "role/findAll")
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.roleList = data
                        if (this.currentRow.roleDtos && this.currentRow.roleDtos.length > 0){
                            this.currentRow.roleIds = this.setRoleIds(this.currentRow.roleDtos)
                        }

                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                })
                .catch(error => {
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        save(){

            this.$refs.form.validate(valid => {
                if(valid){
                    this.currentRow.roleDtos = []
                    this.currentRow.roleIds.forEach((id)=>{
                        this.roleList.forEach((e)=>{
                            if (id == e.id){
                                this.currentRow.roleDtos.push(e)
                            }
                        })
                    })
                    let data = {
                        name:this.currentRow.name,
                        alias:this.currentRow.alias,
                        status : this.currentRow.status,
                        roleDtos:this.currentRow.roleDtos
                    }
                    this.$axios
                    .post(this.baseUrl3 + "user/edit", data)
                    .then(({ data: { msg, data, code } }) => {
                        if (code == 20000) {
                            this.cancel(true)
                        } else {
                            this.$message({ showClose: true, message: msg, type: "error" });
                            console.log(msg);
                        }
                    })
                    .catch(error => {
                        this.$message({
                            showClose: true,
                            message: "系统异常",
                            type: "error"
                        });
                        console.log(error);
                    });
                }
            })
        },
        cancel(val){
            this.$emit('userEditCallback', val)
        },
    },
}
</script>
<style scoped>
.itemWidth{
    width: 50%;
}
</style>
